import { render, staticRenderFns } from "./SetupGuideControl.vue?vue&type=template&id=796569cb&scoped=true&"
import script from "./SetupGuideControl.vue?vue&type=script&lang=js&"
export * from "./SetupGuideControl.vue?vue&type=script&lang=js&"
import style0 from "./SetupGuideControl.vue?vue&type=style&index=0&id=796569cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796569cb",
  null
  
)

export default component.exports